import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";

const navLinks = [
  { label: "首页", path: "/" },
  { label: "国内探花", path: "/category/domestic" },
  { label: "探花精选", path: "/category/selection" },
  { label: "探花91", path: "/category/tanhua91" },
  { label: "探花直播", path: "/category/live" },
  { label: "顶级大师", path: "/category/top-master" },
  { label: "关于我们", path: "/about" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 40);
    };
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-background-50/95 backdrop-blur-md border-b border-background-200/70"
          : "bg-transparent"
      }`}
      aria-label="主导航"
    >
      <div className="w-full px-4 md:px-6 lg:px-10">
        <div className="flex items-center justify-between h-16 md:h-20">
          <Link
            to="/"
            className="flex items-center gap-2 shrink-0"
            aria-label="探花系列精品聚合平台首页"
          >
            <div className="w-8 h-8 md:w-9 md:h-9 rounded-lg bg-primary-500 flex items-center justify-center">
              <span className="text-background-50 font-bold text-sm md:text-base">探</span>
            </div>
            <span
              className={`font-heading text-lg md:text-xl font-bold tracking-tight transition-colors ${
                scrolled ? "text-foreground-950" : "text-background-50"
              }`}
            >
              探花系列
            </span>
          </Link>

          <div className="hidden lg:flex items-center gap-1">
            {navLinks.map((link) => {
              const isActive =
                link.path === "/"
                  ? location.pathname === "/"
                  : location.pathname.startsWith(link.path);
              return (
                <Link
                  key={link.path}
                  to={link.path}
                  className={`px-3 py-2 rounded-md text-sm font-medium transition-colors whitespace-nowrap ${
                    isActive
                      ? scrolled
                        ? "text-primary-600 bg-primary-50"
                        : "text-background-50 bg-background-50/20"
                      : scrolled
                        ? "text-foreground-700 hover:text-foreground-950 hover:bg-background-100"
                        : "text-background-100 hover:text-background-50 hover:bg-background-50/10"
                  }`}
                >
                  {link.label}
                </Link>
              );
            })}
          </div>

          <div className="flex items-center gap-3">
            <Link
              to="/about"
              className={`hidden md:inline-flex items-center gap-1.5 px-4 py-2 rounded-md text-sm font-medium transition-all whitespace-nowrap ${
                scrolled
                  ? "bg-primary-500 text-background-50 hover:bg-primary-600"
                  : "bg-background-50 text-foreground-950 hover:bg-background-100"
              }`}
            >
              <i className="ri-customer-service-line w-4 h-4 flex items-center justify-center"></i>
              联系我们
            </Link>
            <button
              className="lg:hidden p-2 rounded-md transition-colors"
              onClick={() => setMobileOpen(!mobileOpen)}
              aria-label={mobileOpen ? "关闭菜单" : "打开菜单"}
              aria-expanded={mobileOpen}
            >
              <i
                className={`${mobileOpen ? "ri-close-line" : "ri-menu-line"} w-5 h-5 flex items-center justify-center ${scrolled ? "text-foreground-950" : "text-background-50"}`}
              ></i>
            </button>
          </div>
        </div>
      </div>

      {mobileOpen && (
        <div className="lg:hidden bg-background-50/98 backdrop-blur-lg border-b border-background-200/70">
          <div className="px-4 py-4 space-y-1">
            {navLinks.map((link) => {
              const isActive =
                link.path === "/"
                  ? location.pathname === "/"
                  : location.pathname.startsWith(link.path);
              return (
                <Link
                  key={link.path}
                  to={link.path}
                  className={`block px-3 py-2.5 rounded-md text-sm font-medium transition-colors ${
                    isActive
                      ? "text-primary-600 bg-primary-50"
                      : "text-foreground-700 hover:text-foreground-950 hover:bg-background-100"
                  }`}
                >
                  {link.label}
                </Link>
              );
            })}
          </div>
        </div>
      )}
    </nav>
  );
}